<div class="tab-container">
   <ul class="nav nav-tabs">
    <li #tab class="text-center small" [class.active]="isHome()">
      <a data-toggle="tab" [href]="redirectToHomepage">
        <img *ngIf="!isHome()" class="home-size" src="assets/images/home-white.svg">
        <img *ngIf="isHome()" class="home-size" src="assets/images/home-selected.svg">
      </a>
  </li>
    <li
      #tab
      [class.active]="isCurrent(i)"
      *ngFor="let link of navLinks; let i = index"
      (click)="clickOnTab(link.path)"
      (auxclick)="clickOnTab(link.path)"
    >
      <a  data-toggle="tab">
        {{ ((link?.label || title(link)) | translate) || 'Loading...' }}
       <span class="tab-close" (click)="closeTab($event, i)">
          <i class="zmdi zmdi-close"></i>
        </span>
      </a>
    </li>
  </ul>
</div>
